import { api } from './client';
import type { SessionUser } from '../types';

export function me(): Promise<{ user: SessionUser }> {
  return api('/api/auth/me');
}

export function login(email: string, password: string): Promise<{ user: SessionUser }> {
  return api('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export function logout(): Promise<{ ok: true }> {
  return api('/api/auth/logout', { method: 'POST' });
}
